export default {
    animation: Boolean | Object,
    ARIATemplate: String,
    culture: String,
    dateInput: Boolean,
    dates: Array,
    depth: String,
    disableDates: Array | Function,
    footer: String | Function,
    format: String,
    max: Date,
    min: Date,
    month: Object,
    weekNumber: Boolean,
    parseFormats: Array,
    start: String,
    value: String | Date,

    // Events
    change: Function,
    close: Function,
    open: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoDatePicker/DatePickerProps.js